export default __webpack_public_path__ + "static/media/calendar-icon.68f087f0.svg";